// components/IconNode.tsx
import { Handle, Position } from '@xyflow/react';
import React from 'react';

export const IconNode = ({ data }) => {
  return (
    <div
      style={{
        padding: 12,
        border: '1px solid rgba(59, 130, 246, 0.1)',
        borderRadius: 12,
        background: '#1a1b2e',
        minWidth: 120,
        textAlign: 'center',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
      }}
    >
      <div style={{ fontSize: 24, marginBottom: 6 }}>
        {data.Icon}
      </div>
      <div style={{
        color: '#fff',
        fontSize: "16px"
      }}>{data.label}</div>

      {/* TARGET handles */}
      <Handle type="target" position={Position.Top} id="top" style={{ background: "transparent", border: "none" }} />
      <Handle type="target" position={Position.Right} id="right" style={{ background: "transparent", border: "none" }} />
      <Handle type="target" position={Position.Bottom} id="bottom" style={{ background: "transparent", border: "none" }} />
      <Handle type="target" position={Position.Left} id="left" style={{ background: "transparent", border: "none" }} />

      {/* SOURCE handles */}
      <Handle type="source" position={Position.Top} id="top" style={{ background: "transparent", border: "none" }} />
      <Handle type="source" position={Position.Right} id="right" style={{ background: "transparent", border: "none" }} />
      <Handle type="source" position={Position.Bottom} id="bottom" style={{ background: "transparent", border: "none" }} />
      <Handle type="source" position={Position.Left} id="left" style={{ background: "transparent", border: "none" }} />
    </div >
  );
};
